require('./cardModifyLimitSliderSection.scss');
//@vendor
const React = require('react');
const PropTypes = require('prop-types');
//@commons
const { FormattedText, formatText } = require('core/i18n').i18n;
const OKSliderInput = require('commonsComponents/OKSliderInput');
//@utilities
const { getCurrencySymbol, formatAmount } = require('utilities/currencyHelper');

class CardModifyLimitSliderSection extends React.Component {
    render() {
        const { immCard, availableLimits, handleLimitChange, minimumLimit, maximumLimit, isLimitInvalid, defaultLimit } = this.props;
        const currencySign = getCurrencySymbol(immCard.get('limit'));
        const minLabel = `${formatText('cardModifyLimitSliderSection-cardModifyLimitSliderSection_min')} ${formatAmount(minimumLimit, undefined, 0)}`;
        const maxLabel = `${formatText('cardModifyLimitSliderSection-cardModifyLimitSliderSection_max')} ${formatAmount(maximumLimit, undefined, 0)}`;

        let errorState = false;
        let errorMessage;

        if (isLimitInvalid) {
            errorState = true;
            errorMessage = formatText('cardModifyLimitSliderSection-selectedLimitEqualsCurrent');
        }

        return (
            <section className="card-modify-limit-slider-section">
                <header className="card-modify-limit-slider-section__header">
                    <FormattedText value="cardModifyLimitSliderSection-title" />
                </header>
                <div className="card-modify-limit-slider-section__body">
                    <div className="card-modify-limit-slider-section__slider">
                        <OKSliderInput
                            errorMessage={errorMessage}
                            errorState={errorState}
                            minLabel={minLabel}
                            maxLabel={maxLabel}
                            marks={availableLimits}
                            defaultValue={defaultLimit}
                            onChange={handleLimitChange}
                            unit={currencySign}
                        />
                    </div>
                </div>
            </section>
        );
    }
}

CardModifyLimitSliderSection.propTypes = {
    immCard: PropTypes.object.isRequired,
    availableLimits: PropTypes.object.isRequired,
    handleLimitChange: PropTypes.func.isRequired,
    minimumLimit: PropTypes.number.isRequired,
    maximumLimit: PropTypes.number.isRequired,
    isLimitInvalid: PropTypes.bool.isRequired,
    defaultLimit: PropTypes.number.isRequired
};

module.exports = CardModifyLimitSliderSection;
